

























































































import Vue from 'vue';
import _ from 'lodash';
import Requester from '../../requester';

import { UsuarioNovoFormData } from '../../../../back/src/types';
import Carregando from '../../components/Carregando.vue';

export default Vue.extend({
  name: 'UsuariosCadastrar',
  components: {
    Carregando,
  },
  data() {
    return {
      loading: {
        conviteUsuario: true,
        submit: false,
      },
      conviteUsuario: null,
      form: {
        nome: '',
        email: '',
        emailConfirmacao: '',
        senha: '',
        senhaConfirmacao: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        email: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const emailPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return (v && emailPattern.test(v)) || 'E-mail inválido';
          },
        ],
      },
    };
  },
  computed: {
    token(): string {
      return this.$route.query.token as string;
    },
    rulesEmailConfirmacao() {
      return [
        () => (this.form.email === this.form.emailConfirmacao) || 'Confirmação deve ser igual ao email',
      ];
    },
    rulesSenhaConfirmacao() {
      return [
        () => (this.form.senha === this.form.senhaConfirmacao) || 'Confirmação deve ser igual à senha',
      ];
    },
    formNome(): Vue & { validate: () => boolean } {
      return this.$refs.formNome as Vue & { validate: () => boolean };
    },
    formEmail(): Vue & { validate: () => boolean } {
      return this.$refs.formEmail as Vue & { validate: () => boolean };
    },
    formSenha(): Vue & { validate: () => boolean } {
      return this.$refs.formSenha as Vue & { validate: () => boolean };
    },
  },
  async mounted() {
    // Usuário logado
    if (this.$store.getters.token) {
      this.$root.$emit('avisoSnackbar', {
        color: 'info',
        text: 'Você já está logado no sistema.',
      });
      this.$router.push({ name: 'Home' });
    }
    await this.buscaConviteUsuario();
  },
  methods: {
    touchEmailConfirmacao() {
      if (this.form.emailConfirmacao !== '') {
        this.formEmail.validate();
      }
    },
    touchSenhaConfirmacao() {
      if (this.form.senhaConfirmacao !== '') {
        this.formSenha.validate();
      }
    },
    async buscaConviteUsuario() {
      this.loading.conviteUsuario = true;
      try {
        const response = await Requester.conviteUsuario.conviteUsuario(this.token);
        if (response.errors.length > 0) {
          this.conviteUsuario = null;
        } else {
          this.conviteUsuario = response.data;
          this.form.email = this.conviteUsuario.email || '';
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.conviteUsuario = false;
      }
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      if (!this.formNome.validate()
        || !this.formEmail.validate()
        || !this.formSenha.validate()
      ) {
        this.loading.submit = false;
        return;
      }
      const usuarioNovoFormData: UsuarioNovoFormData = {
        nome: this.form.nome,
        email: this.form.email,
        senha: this.form.senha,
        token: this.token,
      };
      try {
        const response = await Requester.usuario.criaUsuario(usuarioNovoFormData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Cadastro efetuado com sucesso. Bem-vindo ao sistema!' });
          this.$store.dispatch('login', response.data);
          this.$router.push({ name: 'Home' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
